import { render, staticRenderFns } from "./Breadcrump.vue?vue&type=template&id=049fc4c5&"
import script from "./Breadcrump.vue?vue&type=script&lang=js&"
export * from "./Breadcrump.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrump.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/dmr/Documents/Vue/rexel_app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs,VFlex,VIcon})
